/* Matched to DataTable.module.css so a page mixing panels and Figma-sized
   tables reads as one surface: same 1124px column, same border colour, same
   header weight. */
.panel {
  display: flex;
  flex-direction: column;
  width: var(--table-w);
  max-width: 100%;
  border: 1px solid var(--border-cell);
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px 12px;
  border-bottom: 1px solid var(--border-cell);
}

.headText { min-width: 0; }

.title {
  margin: 0;
  color: var(--text-header);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.caption {
  margin: 3px 0 0;
  color: var(--text-muted);
  font-size: 12px;
  line-height: 16px;
}

.actions { display: flex; align-items: center; gap: 8px; flex: none; }

.body { padding: 14px 18px 16px; min-width: 0; overflow-x: auto; }
.dense .body { padding: 0; }

.footnote {
  margin: 0;
  padding: 10px 18px 13px;
  border-top: 1px solid var(--border-cell);
  color: var(--text-muted);
  font-size: 11px;
  line-height: 16px;
}

/* ---- segmented control ---- */
.segmented {
  display: inline-flex;
  padding: 2px;
  border: 1px solid var(--border-control);
  border-radius: 8px;
  background: #fafbfc;
}

.segment {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 5px 11px;
  border-radius: 6px;
  color: var(--text-muted);
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
}
.segment:hover { color: var(--text-value); }

.segmentOn {
  background: #fff;
  color: var(--text-header);
  box-shadow: 0 1px 2px rgb(0 0 0 / 8%);
}

.empty {
  margin: 0;
  padding: 18px 2px;
  color: var(--text-muted);
  font-size: 13px;
  line-height: 19px;
}
